<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini" @submit.native.prevent="onSubmit">
            <el-form-item class="query-form-item">
                <formXPItem1 :queryTemp="query" ref="formXPItem1Ref"/>

                <el-form-item label="是否我的选品：" class="query-form-item">
                    <el-select v-model="query.is_my_analysis" placeholder="请选择" size="mini" style="width: 100px;">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="我的选品" :value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="忽略原因：">
                    <el-select v-model="query.disregarded_reason" placeholder="请选择" size="mini">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="同款已分析" value="同款已分析"></el-option>
                        <el-option label="找不到同款" value="找不到同款"></el-option>
                        <el-option label="利润不符" value="利润不符"></el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" @click="onSubmit" size="mini" native-type="submit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>

            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                                :icon-class="scope.row.category_state.toUpperCase()"
                                style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="类目" min-width="360" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>

            <el-table-column label="忽略原因" width="120" align="center">
                <template slot-scope="scope">
                    <div class="canClick" @click="ignoreReasonChange(scope.row)">
                        {{ scope.row.disregarded_reason }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="选品原则" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.selection_principle }}</div>
                </template>
            </el-table-column>

            <el-table-column label="标品类型" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.standard_product_type == -1 ? '未录入' : scope.row.standard_product_type }}</div>
                </template>
            </el-table-column>

            <el-table-column label="专利" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateVal(scope.row)" size="mini">{{scope.row.patent_value ? scope.row.patent_value : '-'}}</el-button><br/><br/>
                    <el-button type="success" @click="uploadPatentFile(scope.row)" size="mini">上传</el-button>
                    <el-button type="success" @click="downFile(scope.row.patent_file)" size="mini" :disabled="!scope.row.patent_file">下载</el-button>
                </template>
            </el-table-column>

            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>

            <el-table-column label="销售价格" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.selling_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品链接" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="1688产品价格" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.ali_pic_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="1688产品标题" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="退货率" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ parseFloat((scope.row.refund_rate || 0) * 100).toFixed(2) }}%</div>
                </template>
            </el-table-column>

            <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}*{{ scope.row.wide }}*{{
                        scope.row.height
                        }}-{{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="运费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运费单价/kg" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_unit_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="运输模式" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>

            <el-table-column label="运费差" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_difference }}</div>
                </template>
            </el-table-column>

            <el-table-column label="平台佣金" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.platform_commission }}</div>
                </template>
            </el-table-column>
            <el-table-column label="亚马逊物流配送费" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.delivery_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="退货费用" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.refund_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Vat税费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.vat_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月仓储费" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月仓储费" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="美国旺季差额" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.us_peak_season_balance }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格(免税)" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月利润" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1-9月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月投资回报率" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{
                        scope.row['early_investment_return_rate'] ? accMul(scope.row['early_investment_return_rate'],
                        100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.late_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="10-12月投资回报率" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{
                        scope.row['late_investment_return_rate'] ? accMul(scope.row['late_investment_return_rate'], 100)
                        + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="利润率(含税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="利润率(免税)" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate_no_tax'] ? accMul(scope.row['profit_rate_no_tax'], 100) + '%' : '-'}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="类目树" min-width="180" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category_tree }}</div>
                </template>
            </el-table-column>
            <el-table-column width="110" align="center" label="父asin">
                <template slot-scope="scope">
                    <span>{{ scope.row.parent_asin }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上架时间" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.listed_since }}</div>
                </template>
            </el-table-column>

            <el-table-column label="品牌" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.brand }}</div>
                </template>
            </el-table-column>
            <el-table-column label="评分" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating }}</div>
                </template>
            </el-table-column>

            <el-table-column label="评论数" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.rating_count }}</div>
                </template>
            </el-table-column>

            <el-table-column label="是否季节性" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.is_seasonality == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="季节" width="70" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.season }}</div>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.create_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="分配采购时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_developer_time }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="320" align="center" fixed="right">
                <template slot-scope="scope">
<!--                    <el-button type="primary" size="mini" v-show="showOperate" @click="operateFunc(scope.row, 1)">-->
<!--                        操作-->
<!--                    </el-button>-->
<!--                    <el-button type="primary" size="mini" v-show="showPurchase" @click="purchaseFunc(scope.row)">-->
<!--                        采购-->
<!--                    </el-button>-->
                    <el-button type="success" size="mini" @click="detailFunc(scope.row)">
                        详情
                    </el-button>
                    <el-button type="warning" size="mini" @click="unignore(scope.row)">
                        取消忽略
                    </el-button>
<!--                    <el-button type="success" size="mini" @click="exportFunc(scope.row)">-->
<!--                        导出-->
<!--                    </el-button>-->
                    <el-button type="danger" size="mini" @click="deleteFunc(scope.row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <addBid
                :visible="showAddRecord"
                :title="editType == 0 ?'添加爬取排名Asin任务' : '成本分析操作'"
                :copyData="copyData"
                :editType='editType'
                @close-callback="closeCllback"
                @refreshList="refreshList"
        ></addBid>
        <detail-preview ref="detailPreview"></detail-preview>
        <self-build-modal :visible="showSelfBuild" @click="closeCllback" @showDetail="showDetail"
                          @close-callback="closeCllback"></self-build-modal>

        <updatePatent ref="updatePatentDom" @close-callback="closeCllback"></updatePatent>
        <ignoreModal ref="ignoreModalDom" @close-callback="ignoreCloseCallback"></ignoreModal>
    </div>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import addBid from './addBid'
    import {downloadFileUrl} from '@/utils/method'
    import {
        cost_analysis_personal_add_to_purchase_list,
        cost_analysis_personal_analysis_list,
        cost_analysis_personal_cancel_assign, cost_analysis_selfbuild_deleted
    } from '@/api/advAnalys/advAnalys.js'
    // import BasicConfigurationData from './basicConfigurationData'
    // import categoryList from './categoryList'
    // import addParse from './addPrase'
    import ChildInfoModal from './childInfoModal.vue'
    import DetailPreview from '@/views/warehouse/detailPreview.vue'
    import SelfBuildModal from '@/views/costAnalysis/selfBuildModal.vue'
    import updatePatent from './components/updatePatent'
    import ignoreModal from './components/ignoreModal'

    let timer = null
    export default {
        name: 'myChoice',
        components: {
            SelfBuildModal,
            DetailPreview,
            ChildInfoModal,
            ignoreModal,
            // BasicConfigurationData,
            addBid,
            updatePatent,
            // categoryList,
            // addParse,
        },
        computed: {
            showUnassign() {
                return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
            },
            showOperate() {
                return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
            },
            showPurchase() {
                return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
            },
        },
        data() {
            return {
                showSelfBuild: false,
                rootCategoryList: [],
                usList: [],
                ukList: [],
                deList: [],
                imgStatusList: [
                    {name: '全部', value: undefined},
                    {name: '搜索不到图片', value: 1},
                    {name: '暂无图片', value: 2},
                    {name: '有图片', value: 3},
                ],
                isFold: true,
                editType: 0,
                copyData: {},
                manualRootShow: false,
                showBasicConfigDataModal: false,
                showAddParseModal: false,
                showCategoryList: false,
                manualRootList: [],
                showAddRecord: false,
                currentId: '',
                tableHeight: null,
                errorMsg: '',
                errorInfoShow: false,
                ctrl: {
                    DownloadListDialogVisible: false,
                    uploadDialogVisible: false,
                    bidDialogVisible: false,
                    childInfoVisible: false,
                },
                typeArr: [{
                    index: 1,
                    title: '广告层面'
                },
                    {
                        index: 2,
                        title: '逻辑层面'
                    }
                ],
                query: {
                    page: 1,
                    limit: 10,
                    total: 0,
                },
                record_id: 0,
                activeName: 'antiInternal',
                list: [],
                disabled: false,
                listDisabled: false,
                loading: false,
                parseStatusList: [],
                updateData: {},
                childInfo: {},
                multipleSelection: [],
            }
        },
        mounted() {
            this.getList()
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        watch: {
            tableHeight(val) {
                this.tableHeight = val
            }
        },
        destroyed() {
            clearInterval(timer)
        },
        methods: {
            ignoreCloseCallback(data) {
                if (data.flag) {
                    api.cost_analysis_personal_update_field(data).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.getList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            },
            ignoreReasonChange(data){
                this.$refs.ignoreModalDom.openModal(data)
            },
            uploadPatentFile(data){
                this.$refs.updatePatentDom.openModal(2, data)
            },
            updateVal(data) {
                this.$refs.updatePatentDom.openModal(1, data)
            },
            deleteFunc(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.cost_analysis_selfbuild_deleted({id: data.id}).then((res) => {
                        if (res.success) {
                            this.$message.success('删除成功')
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    })
                })
            },
            exportFunc(data) {
                api.operation_index_export({id: data.id}).then((res) => {
                    if (res.success) {
                        this.downFile(res.data)
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
            },
            detailFunc(data) {
                this.$refs.detailPreview.visible = true
                this.$refs.detailPreview.title = '详情展示'
                this.$refs.detailPreview.formData = data
            },
            // 取消分配
            unassignFunc(data) {
                api.cost_analysis_personal_cancel_assign({id: data.id}).then((res) => {
                    if (res.success) {
                        this.$message.success('取消分配成功')
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            // 取消忽略
            unignore(data) {
                api.cost_analysis_personal_cancel_disregarded({id: data.id}).then((res) => {
                    if (res.success) {
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            // 操作
            operateFunc(data, type) {
                let tempDate = JSON.parse(JSON.stringify(data))
                this.editType = type
                this.copyData = tempDate
                this.showAddRecord = true
            },
            // 采购
            purchaseFunc(data) {
                api.cost_analysis_personal_add_to_purchase_list({id: data.id}).then((res) => {
                    if (res.success) {
                        this.$message.success('采购成功')
                        this.getList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.loading = false
                this.$emit('close-callback', isshow)
            },
            handleSelectionChange(val) {
                let arr = []
                val.map(v => {
                    arr.push(v.id)
                })
                arr = Array.from(new Set(arr))
                this.multipleSelection = arr
            },
            seeUrl(row) {
                this.childInfo.title = '1688链接'
                this.childInfo.info = row.href_link
                this.ctrl.childInfoVisible = true
            },
            jumpUrl(url) {
                window.open(url, '_blank')
            },
            //跳转到亚马逊产品页面
            edirectToAsin(data) {
                // let url =
                //     link_us(data.state) +
                //     'dp/' +
                //     data.url_asin_href +
                //     '?th=1&psc=1'
                window.open(data.href_link, '_blank')
            },
            /**
             * 数字相乘
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accMul(arg1, arg2) {
                let m = 0
                m = this.accAdd(m, this.getDecimalLength(arg1))
                m = this.accAdd(m, this.getDecimalLength(arg2))
                return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
            },
            getNum(arg = '') {
                return Number((arg || "").toString().replace('.', ''))
            },
            /**
             * 数字相加
             * @param {*} arg1
             * @param {*} arg2
             * @returns
             */
            accAdd(arg1, arg2) {
                return this.changeNum(arg1, arg2)
            },
            changeNum(arg1 = '', arg2 = '', isAdd = true) {
                const changeInteger = (arg, r, maxR) => {
                    if (r != maxR) {
                        let addZero = ''
                        for (let i = 0; i < maxR - r; i++) {
                            addZero += '0'
                        }
                        arg = Number(arg.toString().replace('.', '') + addZero)
                    } else {
                        arg = this.getNum(arg)
                    }
                    return arg
                }

                let r1, r2, maxR, m
                r1 = this.getDecimalLength(arg1)
                r2 = this.getDecimalLength(arg2)
                maxR = Math.max(r1, r2)
                arg1 = changeInteger(arg1, r1, maxR)
                arg2 = changeInteger(arg2, r2, maxR)
                m = Math.pow(10, maxR)
                if (isAdd) {
                    return (arg1 + arg2) / m
                } else {
                    return (arg1 - arg2) / m
                }
            },

            getDecimalLength(arg = '') {
                try {
                    return arg.toString().split('.')[1].length
                } catch (e) {
                    return 0
                }
            },

            spanMethod({row, column, rowIndex, columnIndex}) {

                const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
                if (rowIndex % 3 == 0) {
                    if (columns.includes(columnIndex)) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                    return {
                        rowspan: 3,
                        colspan: 1
                    }
                } else {
                    if (columns.includes(columnIndex)) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                    return {
                        rowspan: 0,
                        colspan: 0
                    }
                }
            },
            copyDataFunc(data, type) {
                this.showAddRecord = true
                let tempDate = JSON.parse(JSON.stringify(data))
                tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
                tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
                this.editType = type
                this.copyData = tempDate
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: [data.id]}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            showErrorInfo(info) {
                this.errorInfoShow = true
                this.errorMsg = info.parsing_err_msg
            },
            showManualRoot(info) {
                this.manualRootShow = true
                this.manualRootList = info
            },
            getList() {
                this.loading = true
                const tempQuery= this.$refs.formXPItem1Ref.handleQueryData()
                api.admin_cost_analysis_personal_disregarded_list(tempQuery).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        const responseList = res.data.list || []
                        this.list = responseList
                        this.query.total = res.data.total
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                }).catch(() => {
                    this.loading = false
                })
            },
            clickRowHandle(row, column) {
                let update = false
                if (['标题', '类目树', '子类目', '1688产品标题', '颜色', '备注'].includes(column.label)) {
                    this.childInfo.title = column.label
                    let info = row.title
                    if (column.label == '类目树') {
                        info = row.category_tree
                    } else if (column.label == '子类目') {
                        info = row.categories_str
                    } else if (column.label == '颜色') {
                        info = row.color
                    } else if (column.label == '1688产品标题') {
                        info = row.ali_title
                    } else if (column.label == '备注') {
                        info = row.remark
                        update = true
                    }
                    this.childInfo.id = row.id
                    this.childInfo.info = info
                    this.childInfo.update = update
                    this.ctrl.childInfoVisible = true
                }
                if (['折叠', '收起'].includes(column.label)) {
                    this.isFold = !this.isFold
                }
            },
            clickHeaderHandle(row, column) {
                if (['折叠', '收起'].includes(row.label)) {
                    this.isFold = !this.isFold
                }
            },
            handleSortChange(val) {
                if (val.order == 'ascending') {
                    this.query.desc = 'desc'
                    this.query.order = val.prop
                } else if (val.order == 'descending') {
                    this.query.desc = 'asc'
                    this.query.order = val.prop
                }
                this.getList()
            },
            handleClick(tab) {
                this.$nextTick(() => {
                    this.$refs[tab.paneName].getList()
                })
            },
            onSelfBuild() {
                this.showSelfBuild = true
            },
            //重置
            onReset() {
                this.query = {
                    category_state: '',
                    category_id: '',
                    asin: '',
                    screen_type: '',
                    deliver_mode: '',
                    season: undefined,
                    min_freight_difference: undefined,
                    max_freight_difference: undefined,
                    min_weight: undefined,
                    max_weight: undefined,
                    min_early_profit: undefined,
                    max_early_profit: undefined,
                    page: 1,
                    limit: 10,
                    total: 0,
                }
                this.getList()
            },
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            basicData() {
                this.showBasicConfigDataModal = true
            },
            addParse() {
                this.showAddParseModal = true
            },
            // 批量删除
            batchDelete() {
                if (this.multipleSelection.length > 0) {
                    this.$confirm(`确定批量删除已选择项吗?`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                            if (res.code === 0) {
                                this.$message({type: 'success', message: '删除成功'})
                                this.getList()
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(res => {
                            this.$message({type: 'error', message: res.message})
                        })
                    }).catch(() => {
                    })

                } else {
                    this.$message.info('暂未选择批量处理内容')
                }
            },
            // 批量重置
            batchReset() {
                if (this.multipleSelection.length > 0) {
                    this.$confirm(`确定批量重置已选择项吗?`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                            if (res.code === 0) {
                                this.$message({type: 'success', message: '重置成功'})
                                this.getList()
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(res => {
                            this.$message({type: 'error', message: res.message})
                        })
                    }).catch(() => {
                    })

                } else {
                    this.$message.info('暂未选择批量处理内容')
                }
            },
            change() {
                this.getList()
            },
            clearValue() {
                this.query.state = ''
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //上传文件
            onupload() {
                this.ctrl.uploadDialogVisible = true
            },
            //下载列表
            onDownloadList() {
                this.ctrl.DownloadListDialogVisible = true
                this.$nextTick(() => {
                    this.$refs[this.activeName].getList()
                })
            },
            // bid记录列表
            openBidList(data) {
                this.currentId = data.id
                this.ctrl.bidDialogVisible = true
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm('是否重新运行解析任务', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                }
                let list = JSON.parse(JSON.stringify(this.list))
                api.variety_cost_control_analysis_parsing_file({
                    id: row.id,
                    force
                }).then(() => {
                    const index = list.findIndex(item => item.id === row.id)
                    list[index].status = 1
                    this.list = list
                })
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            //添加广告优化记录
            onAddPpc(data) {
                this.record_id = data.id
                this.ctrl.addPpcDialogVisible = true
            },
            // 关闭弹窗回调
            closeCllback(isShow) {
                this.showAddRecord = false
                this.showSelfBuild = false
                this.showAddParseModal = false
                this.ctrl.childInfoVisible = false
                this.updateData = {}
                isShow == true && this.getList()
            },
            refreshList() {
                this.getList()
            },
            showDetail(data) {
                this.showSelfBuild = false
                this.getList()
                this.detailFunc(data)
            },
            update(data) {
                this.updateData = data
                this.showAddRecord = true
            }
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .canClick {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
        min-width: 99px;
        height: 23px;
    }

    .redTxt {
        color: red;
        font-weight: bold;
    }

    .fixedHeight {
        height: 30px;
        line-height: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mini_div .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell {
        padding: 0 0 !important;
    }
</style>
